<!-- エラーメッセージ画面　機種エラー（ガラケー） -->
<template>
  <section class="crly-o-error-error-msg-device">
    <!-- ライフエールロゴ -->
    <div class="crly-o-error-error-msg-device__header logo">
      <img src="@crly/assets/img/common/logo.png" />
    </div>
    <!-- 特典がいっぱい！ 画像 -->
    <div class="crly-o-error-error-msg-device__contents">
      <img
        class="crly-o-error-error-msg-device__image"
        src="@crly/assets/img/member/bnr_yid_sp.jpg"
      />
      <!-- メッセージ -->
      <p class="crly-o-error-error-msg-device__message">
        {{ $t("errorMsgDevice.device.text") }}
      </p>
    </div>
    <!--　フッター　コピーライト表示 -->
    <div class="crly-o-error-error-msg-device__footer">
      <p>{{ $t("errorMsgDevice.device.copyright1") }}</p>
      <p>{{ $t("errorMsgDevice.device.copyright2") }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "CrlyOrganismsErrorMsgDevice"
};
</script>

<style lang="scss">
@import "@crly/assets/css/common/common.scss";
@import "@crly/assets/css/organisms/error/errorMsgDevice.scss";
</style>
